const roundCurrency = (value) => {
  const parsed = Number(value);
  if (!Number.isFinite(parsed)) return 0;
  return Math.round((parsed + Number.EPSILON) * 100) / 100;
};

export const cloneAppliedVoucher = (voucher) => {
  if (!voucher || typeof voucher !== "object") return null;

  const kind =
    voucher.kind === "reward" || voucher.kind === "promo" ? voucher.kind : null;
  if (!kind) return null;

  const amount = roundCurrency(voucher.amount);
  if (amount <= 0) return null;

  const clone = {
    kind,
    code: typeof voucher.code === "string" ? voucher.code : "",
    amount,
  };

  if (kind === "promo") {
    clone.promoPercentRate =
      typeof voucher.promoPercentRate === "number" && Number.isFinite(voucher.promoPercentRate)
        ? voucher.promoPercentRate
        : null;
    clone.promoFixedAmount =
      typeof voucher.promoFixedAmount === "number" && Number.isFinite(voucher.promoFixedAmount)
        ? roundCurrency(voucher.promoFixedAmount)
        : null;
  }

  return clone;
};

export const buildPersistedPricingSummary = ({
  baseTotal,
  finalTotal,
  appliedVoucher,
} = {}) => ({
  baseTotal: roundCurrency(baseTotal),
  finalTotal: roundCurrency(finalTotal),
  voucher: cloneAppliedVoucher(appliedVoucher),
});

export const getPricingDisplaySummary = ({
  liveBaseTotal,
  liveFinalTotal,
  liveVoucher,
  persistedSummary,
  preferPersisted = false,
} = {}) => {
  if (preferPersisted && persistedSummary) {
    return {
      baseTotal: roundCurrency(persistedSummary.baseTotal),
      finalTotal: roundCurrency(persistedSummary.finalTotal),
      voucher: cloneAppliedVoucher(persistedSummary.voucher),
    };
  }

  return {
    baseTotal: roundCurrency(liveBaseTotal),
    finalTotal: roundCurrency(liveFinalTotal),
    voucher: cloneAppliedVoucher(liveVoucher),
  };
};

const bookingPricingSummary = {
  buildPersistedPricingSummary,
  cloneAppliedVoucher,
  getPricingDisplaySummary,
};

export default bookingPricingSummary;
